/*
 * Copyright (c) Nexign, JSC, 2019.
 */
/**
 *
 * @author Evgenij Tyan
 * @author Yakov Gushchin
 * @version 1.0.1
 * @since 1.0.0
 */
import { createAction } from '../../../../../modules/app/createAction';
import {
    SET_EXTFILTER_ID,
    SET_EXTFILTER_ID_FAILED,
    SET_EXTFILTER_ID_SUCCESSFUL,
    SET_EXTFILTER_ITEM,
    SET_EXTFILTER_ITEM_FAILED,
    SET_EXTFILTER_ITEM_SUCCESSFUL,
} from '../constants/extFilterConstructorConstants';
import {
    TSetExtFilterAction,
    TSetExtFilterIdAction,
    TSetExtFilterIdFailedAction,
    TSetExtFilterIdSuccessfulAction,
    TSetExtFilterItemsFailedAction,
    TSetExtFilterItemsSuccessfulAction,
} from '../types/extFilterActionTypes';
import { IExtFilterItem, IExtFilterItemValue } from '../types/extFilterTypes';

/*
* -------------------------------------------
*           SET SELECTED FILTER
* -------------------------------------------
*/

export const setExtFilterId = (payload: string): TSetExtFilterIdAction =>
    createAction(SET_EXTFILTER_ID, payload);
export const setExtFilterIdSuccessful = (payload: string): TSetExtFilterIdSuccessfulAction =>
    createAction(SET_EXTFILTER_ID_SUCCESSFUL, payload);
export const setExtFilterIdFailed = (payload: string): TSetExtFilterIdFailedAction =>
    createAction(SET_EXTFILTER_ID_FAILED, payload);

/*
* -------------------------------------------
*       SET SELECTED FILTER ITEM ATTR
* -------------------------------------------
*/

export const setExtFilter = (payload: IExtFilterItemValue): TSetExtFilterAction =>
    createAction(SET_EXTFILTER_ITEM, payload);
export const setExtFilterItemsSuccessful = (payload: IExtFilterItem[]): TSetExtFilterItemsSuccessfulAction =>
    createAction(SET_EXTFILTER_ITEM_SUCCESSFUL, payload);
export const setExtFilterItemsFailed = (payload: string): TSetExtFilterItemsFailedAction =>
    createAction(SET_EXTFILTER_ITEM_FAILED, payload);

export type TExtFilterConstructor =
    TSetExtFilterAction
    | TSetExtFilterIdAction
    | TSetExtFilterIdFailedAction
    | TSetExtFilterIdSuccessfulAction
    | TSetExtFilterItemsFailedAction
    | TSetExtFilterItemsSuccessfulAction;
